<template>
  <v-main
    id="policy_details"
    class="policy-overview-content py-0 mb-5"
    role="presentation"
    style="max-width: 1024px !important; margin: auto"
  >
    <template v-if="beneficiaryStep === -1">
      <!-- ! RestrictedPolicy -->
      <v-container class="maxContainerWidth" v-if="showRestrict && accessNotNone">
        <RestrictedPolicy />
      </v-container>
      <!-- ! NOT RestrictedPolicy -->
      <v-container class="maxContainerWidth">
        <!-- My Primerica Header -->
        <v-row class="text-white py-4">
          <v-col
            cols="12"
            class="d-flex"
            :class="
              policiesForSelect.length > 1 && !$vuetify.display.smAndDown
                ? 'align-center'
                : 'align-start'
            "
          >
            <!-- My Primerica Header -->
            <svg
              width="55px"
              height="40px"
              viewBox="15 10 42 35"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>Life Insurance</title>
              <defs>
                <radialGradient
                  cx="51.4182051%"
                  cy="82.466338%"
                  fx="51.4182051%"
                  fy="82.466338%"
                  r="70.4153415%"
                  gradientTransform="translate(0.514182,0.824663),scale(0.698177,1.000000),rotate(77.265059),scale(1.000000,1.064158),translate(-0.514182,-0.824663)"
                  id="radialGradient-511"
                >
                  <stop stop-color="#36A5DD" offset="0%" />
                  <stop stop-color="#286EB6" offset="100%" />
                </radialGradient>
                <radialGradient
                  cx="51.4182051%"
                  cy="82.466338%"
                  fx="51.4182051%"
                  fy="82.466338%"
                  r="303.039601%"
                  gradientTransform="translate(0.514182,0.824663),scale(0.234861,1.000000),rotate(45.568421),scale(1.000000,1.064158),translate(-0.514182,-0.824663)"
                  id="radialGradient-611"
                >
                  <stop stop-color="#36A5DD" offset="0%" />
                  <stop stop-color="#286EB6" offset="100%" />
                </radialGradient>
              </defs>
              <g id="Nav-House" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Blue-Level-Icon2" transform="translate(12.000000, 11.000000)">
                  <g>
                    <polygon
                      id="Rectangle"
                      fill="#18344E"
                      points="6.39435792 8.78385542 19.6767558 1.41036145 32.9435943 8.78385542 32.9591537 25.7838554 6.39435792 25.7838554"
                    />
                    <path
                      d="M0.0481927711,10.1108701 L4.76705398,10.1181643 L4.76705398,27.2296386
                    L34.468165,27.2296386 L34.468165,10.1181643 L39.0481928,10.1181643 L31.4197199,6.14855624 L31.4191647,0.143222694 L26.1423416,0.143222694
                    L26.1423416,3.4009463 L19.6152197,0.000722891566 L0.0481927711,10.1108701 Z M6.40023796,9.21092306 L19.5343354,2.41036145 L32.939759,9.35099862
                    L32.939759,19.759759 L6.39156627,19.759759 L6.40023796,9.21092306 Z"
                      id="Blue-Level-Icon"
                      fill="url(#radialGradient-511)"
                    />
                    <path
                      d="M6.89402838,19.259759 L6.89057366,24.499759 L32.4563424,24.499759 L32.4589087,19.259759 L6.89402838,19.259759 Z"
                      id="Rectangle"
                      stroke="#18344E"
                      fill="url(#radialGradient-611)"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <div class="w-100 d-flex align-center justify-space-between flex-wrap">
              <h1 role="heading" aria-level="1" class="text-h1">
                {{ __t(titleLocaleKey) }}
              </h1>
              <div v-if="havePolicies && !loading" class="view-policy-section">
                <!-- View Policy Dropdown -->
                <!-- && policiesForSelect.length > 1 -->
                <v-row v-if="policiesForSelect.length > 1" class="multi-policies">
                  <v-col cols="auto" class="text-white ma-0 pa-0"> </v-col>
                  <v-col cols="auto" class="ma-0 pa-0">
                    <OnexSelect
                      id="select-policy"
                      class="pa-0"
                      :items="policiesForSelect"
                      :model-value="selectedPolicyIndexMapped"
                      variant="solo"
                      :label="$t('L_policy_view_policy')"
                      @update:model-value="changePolicy"
                      :width="'300px'"
                      :menu-props="{ location: 'bottom center', scrollStrategy: 'close' }"
                    />
                  </v-col>
                </v-row>
                <!-- Policy Number -->
                <v-row v-else class="single-policy">
                  <v-col>
                    <div class="d-inline">
                      <h3>
                        {{ $t('L_policy_policy_number') }}:
                        <span class="font-weight-regular">{{
                          policiesForCardStack[policiesForCardStack.length - 1].policyNumber
                        }}</span>
                      </h3>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Policy Overview Tabs and Window -->
        <v-sheet id="tabs-container">
          <v-tabs
            class="pri-tabs"
            id="policy_tabs_main"
            v-model="activeTab"
            align-tabs="center"
            slider-color="primary"
            grow
            bg-color="#FFFFFF"
            aria-orientation="horizontal"
          >
            <v-tab
              v-if="havePolicies"
              value="my-life-insurance"
              @click="
                $router.replace({
                  name: RouteNames.POLICY_DETAILS,
                  params: { contractId: selectedPolicyIndex },
                })
              "
              color="black"
              id="my_policy_tab"
              class="mx-auto px-0"
              :class="activeTab === 'my-life-insurance' ? 'colorselected' : 'colorunselected'"
            >
              <div class="px-0" :class="$vuetify.display.xs ? 'font-size--12' : 'font-size--16'">
                {{ __t('L_policy_my_policy') }}
              </div>
            </v-tab>
            <v-tab
              v-if="showGuidanceCalculatorTab"
              value="my-guidance-calculator"
              @click="$router.replace({ name: RouteNames.GUIDANCE_CALCULATOR })"
              :id="'guidance_calculator_tab'"
              class="mx-auto px-0"
              :class="activeTab === 'my-guidance-calculator' ? 'colorselected' : 'colorunselected'"
            >
              <div
                class="px-0 wrapText"
                :class="$vuetify.display.xs ? 'font-size--12' : 'font-size--16'"
              >
                {{ $t('L_policy_guidance_calculator') }}
              </div>
            </v-tab>
            <v-tab
              @click="$router.replace({ name: RouteNames.TERM_LIFE_BENEFITS })"
              value="my-policy-learn-more"
              id="termlife_benefits_tab"
              class="mx-auto px-0"
              :class="activeTab === 'my-policy-learn-more' ? 'colorselected' : 'colorunselected'"
            >
              <div class="px-0" :class="$vuetify.display.xs ? 'font-size--12' : 'font-size--16'">
                {{ $t('L_policy_learn_more') }}
              </div>
            </v-tab>
            <!-- <v-spacer></v-spacer> -->
          </v-tabs>
          <v-tabs-window v-model="activeTab" class="pri-tab-items">
            <v-tabs-window-item
              v-if="havePolicies"
              v-touch="swipeFunctionalities"
              value="my-life-insurance"
            >
              <MyPolicyTab />
              <LoadingIndicator :loading="isLoading" />
            </v-tabs-window-item>
            <v-tabs-window-item
              v-if="showGuidanceCalculatorTab"
              v-touch="swipeFunctionalities"
              value="my-guidance-calculator"
              class="mb-16"
            >
              <GuidanceCalculatorTab />
              <LoadingIndicator :loading="isLoading" />
            </v-tabs-window-item>
            <v-tabs-window-item v-touch="swipeFunctionalities" value="my-policy-learn-more">
              <PolicyBenefitsTab />
              <LoadingIndicator :loading="isLoading" />
            </v-tabs-window-item>
          </v-tabs-window>
        </v-sheet>
      </v-container>
    </template>
  </v-main>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import { mapActions, mapState, mapStores } from 'pinia';
import { useDimeguidanceStore } from '@/modules/dimeguidance/store/dimeguidance.store';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { useChildRiderStore } from '@/modules/childrider/store/childrider.store';
import PaginationDots from '@/components/PaginationDots/PaginationDots.vue';
import { RouteNames } from '@/router/routeNames';
import RestrictedPolicy from './components/RestrictedPolicy.vue';
import { usePolicyStore } from './store/policy.store';
import type { IPolicyStorePolicy } from './store/policyStore.model';
import MyPolicyTab from './PolicyMyPolicy/MyPolicyTab.vue';
import GuidanceCalculatorTab from './PolicyGuidanceCalculator/GuidanceCalculatorTab.vue';
import PolicyBenefitsTab from './PolicyLearnMore/PolicyBenefitsTab.vue';
import { mdiCalendarRangeOutline, mdiCurrencyUsd } from '@mdi/js';
import { OnexSelect } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'PolicyDetails',
  components: {
    RestrictedPolicy,
    PaginationDots,
    LoadingIndicator,
    MyPolicyTab,
    GuidanceCalculatorTab,
    PolicyBenefitsTab,
    OnexSelect,
  },
  data: () => ({
    showNavButtons: document.documentElement.clientWidth > 1339,
    routerTransitionName: '',
    swipeFunctionalities: function () {
      return {
        left: () => this.swipeLeft(),
        right: () => this.swipeRight(),
      };
    },
    activeTab: 'my-life-insurance',
    RouteNames,
    mdiCurrencyUsd,
    mdiCalendarRangeOutline,
    selectedPolicyIndexMapped: 0,
  }),
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(usePolicyStore, {
      currentPolicy: 'currentPolicy',
      isPending: 'isPending',
      policies: 'policies',
      selectedPolicyIndex: 'selectedPolicyIndex',
      restrictCodeMessage: 'restrictCodeMessage',
      clientCommunicationsPhone: 'clientCommunicationsPhone',
      beneficiaryStep: 'beneficiaryStep',
      paymentStep: 'paymentStep',
      withDrawalDateStep: 'withDrawalDateStep',
      paymentInfoLoading: 'paymentInfoLoading',
      loading: 'policyInfoLoading',
      changeBankAccountStep: 'changeBankAccountStep',
      payMethodChange: 'payMethodChange',
    }),
    ...mapState(useDimeguidanceStore, {
      dimeLoading: 'dimeLoading',
    }),
    accessNotNone() {
      return this.currentPolicy?.data?.access !== 'NONE';
    },
    showRestrict() {
      if (this.policiesForSelect.length === 0) {
        if (
          this.$route.name === RouteNames.TERM_LIFE_BENEFITS ||
          this.$route.name === RouteNames.GUIDANCE_CALCULATOR
        ) {
          return false;
        }
        return true;
      }
      return '';
    },
    havePolicies() {
      return !!(this.policiesForSelect.length > 0);
    },
    showGuidanceCalculatorTab() {
      return !CapacitorFacade.isNativePlatform();
    },
    policiesForSelect() {
      return this.policies
        .filter(
          (policy: IPolicyStorePolicy) =>
            !policy.restricted && parseInt(policy.contractId, 10) !== 0
        )
        .map((policy: IPolicyStorePolicy, index: number) => ({
          title: this.formatSelectText(policy),
          value: index,
        }));
    },
    // This only happens if there's only 1 policy so we can use selectedPolicyIndex
    policiesForCardStack() {
      const allPolicies = this?.policies
        ?.slice(this.selectedPolicyIndex, this.policies.length)
        ?.reverse();
      return allPolicies.filter(
        (policy: IPolicyStorePolicy) => !policy.restricted && parseInt(policy.contractId, 10) !== 0
      );
    },
    selectedPolicy() {
      const currentContractId = this.currentPolicy?.contractId;
      // Find the index that has the same contractId and use it to set the policyData
      const index = this.policies.findIndex(
        (policy: IPolicyStorePolicy) => policy.contractId === currentContractId
      );
      return this.policies[index];
    },
    titleLocaleKey() {
      const company = this.selectedPolicy?.contractId?.slice(0, 2);
      switch (company) {
        case '05':
        case '10':
          return 'L_policy_my_canada_life';
        case '34':
          return 'L_policy_my_nb_life';
        default:
          return 'L_policy_my_primerica_life';
      }
    },
    coverageAmount() {
      return this.selectedPolicy?.totalCoverage;
    },
    isLoading() {
      return this.loading || this.dimeLoading || this.paymentInfoLoading;
    },
  },
  methods: {
    ...mapActions(useChildRiderStore, {
      pullPackages: 'pullPackages',
    }),
    __t(key: string): string {
      return this.$t(key + (this.policyStore.isPending ? '_application' : '')) as string;
    },
    onResize() {
      this.showNavButtons = document.documentElement.clientWidth > 1339;
    },
    async changePolicy(index: number) {
      this.selectedPolicyIndexMapped = index;
      // Find the index that has the same contractId and use it to set the policyData
      const actualPolicyIndex = this.policies.findIndex((policy: IPolicyStorePolicy) =>
        String(this.policiesForSelect[index]?.title ?? '').includes(policy.contractId)
      );
      this.policyStore.changePolicy({ selectedIndex: actualPolicyIndex });
      await this.$router.replace({
        name: RouteNames.POLICY_DETAILS,
        params: { contractId: this.indexPolicy },
      });
    },
    nextPolicy() {
      this.policyStore.nextPolicy();
    },
    prevPolicy() {
      this.policyStore.prevPolicy();
    },
    formatSelectText(policy?: IPolicyStorePolicy) {
      return policy ? `${policy.insuredName?.slice(0, 6)} ${policy.contractId || ''}` : '';
    },
    swipeLeft() {
      if (this.$route.name === RouteNames.POLICY_DETAILS) {
        this.nextPolicy();
        this.setPolicyDropDownToCurrentPolicy();
      }
    },
    swipeRight() {
      if (this.$route.name === RouteNames.POLICY_DETAILS) {
        this.prevPolicy();
        this.setPolicyDropDownToCurrentPolicy();
      }
    },
    routingForTabs() {
      switch ((this.$route?.name as string) || 0) {
        case RouteNames.POLICY_DETAILS:
          this.activeTab = 'my-life-insurance';
          break;
        case RouteNames.GUIDANCE_CALCULATOR:
          this.activeTab = 'my-guidance-calculator';
          break;
        case RouteNames.TERM_LIFE_BENEFITS:
          this.activeTab = 'my-policy-learn-more';
          break;
        default:
          this.activeTab = 'my-life-insurance';
          break;
      }
    },
    setPolicyDropDownToCurrentPolicy() {
      this.selectedPolicyIndexMapped = this.policiesForSelect.findIndex(
        (policy: { title: string; value: number }) =>
          String(policy.title).includes(this.currentPolicy?.contractId)
      );
    },
  },
  mounted() {
    if (!this.accessNotNone) {
      this.$router.push({ name: RouteNames.GUIDANCE_CALCULATOR }); // ({ path: '/policy/guidance' });
    }
    // await this.$store.dispatch('policy/getPolicyOverview');
    this.pullPackages();
    window.addEventListener('resize', () => this.onResize());
    // const tabs = document.getElementById('policy_tabs_main');
    this.routingForTabs();
    this.setPolicyDropDownToCurrentPolicy();
  },
  watch: {
    $route(to, from) {
      const fromPath = from.meta.indexOfRoute;
      const toPath = to.meta.indexOfRoute;
      this.routerTransitionName = fromPath < toPath ? 'card-slide-right' : 'card-slide-left';
      this.routingForTabs();
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.wrapText {
  white-space: break-spaces !important;
  word-break: break-word;
  text-wrap-mode: wrap;
}

.colorselected {
  background-color: #e2f0fe !important;
  color: #063562 !important;
  border-bottom: 2px solid #063562 !important;
}

.colorunselected {
  color: #000000 !important;
  border-bottom: 4px solid #cccccc !important;
}

#tabs-container {
  background-color: transparent !important;
}

@media (min-width: 1200px), (max-width: 767px) {
  .v-tabs__items {
    overflow: visible;
  }
}

/* Transition for router-view */
/* Slide from left */
.card-slide-left-enter-active {
  transition: transform 0.4s ease-out;
}

.card-slide-left-leave-active {
  transition: transform 0.4s ease-in;
}

.card-slide-left-enter {
  transform: translateX(-100%);
  opacity: 1;
}

.card-slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0.5;
}

/* Slide from right */
.card-slide-right-enter-active {
  transition: transform 0.4s ease-out;
}

.card-slide-right-leave-active {
  transition: transform 0.4s ease-in;
}

.card-slide-right-enter {
  transform: translateX(100%);
  opacity: 1;
}

.card-slide-right-leave-to {
  transform: translateX(-100%);
  opacity: 0.5;
}

.zmaxContainerWidth {
  max-width: 960px !important;
}

.navigate_next_css {
  margin-top: 12px;
  margin-left: -18px;
}

.navigate_prev_css {
  margin-left: -22px;
  margin-top: 12px;
  padding-right: 42px;
}

.button_navigation_margin_left {
  margin-left: -5px;
}

/* Transition for buttons */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.next-prev-buttons {
  padding: 10px;
  position: fixed;
  left: 50%;
  top: 536px;
  margin-left: 575px;
  width: 97px;
}

.withDrawalIcon {
  margin-top: -11px !important;
  margin-bottom: 20px !important;
}

.withDrawalTitle {
  margin-top: 5px !important;
}

.pagination-dots {
  margin-top: 16px;
  margin-bottom: 45px;

  @media (min-width: 768px) {
    display: none;
  }
}

// Fonts Based on breakpoint
.my-primerica-header-layout {
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 32px;

  @media (min-width: 576px) {
    padding-left: 0;
    padding-right: 0;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  @media (min-width: 768px) {
    padding-top: 24px;
  }

  .heading_two {
    padding-right: 16px;

    @media (max-width: 575px) {
      padding-right: 0;
      line-height: 24px;
    }
  }
}

// View Policy Dropdown
.view-policy-section {
  @media (max-width: 575px) {
    justify-content: flex-end;
    flex-basis: 100vw;
    margin-bottom: 0;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }

  @media (max-width: 864px) {
    margin-top: 0px;
  }

  .v-list-subheader {
    font-weight: 500;

    @media (max-width: 767px) {
      padding-left: 0;
      padding-right: 0;
      margin-top: 16px;
      height: 30px;
    }

    @media (max-width: 575px) {
      margin-top: 0;
    }

    @media (min-width: 768px) {
      padding-right: 16px;

      > div {
        text-align: right;
        width: 100%;
      }
    }
  }

  #select-policy {
    width: 100%;

    @media (min-width: 576px) {
      padding-left: 0;
      padding-right: 0;
    }

    @media (min-width: 768px) {
      max-width: 247px;
    }
  }
}

// Padding based on breakpoint
.container {
  @media (max-width: 575px) {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 0 !important;
  }
}

:deep(.policy-overview-content) {
  .payment-details .info-title {
    text-align: left;
  }

  .payment-details .info-content {
    text-align: left;
    font-size: 18px;
  }

  .contact-details {
    .theme--light.v-input--is-disabled label.v-label.v-label--active {
      color: #424242;
      font-weight: 500;
    }

    .theme--light.v-text-field.v-input--is-disabled .v-input__slot:before {
      border-image: none;
    }
  }

  .name-header {
    min-width: 100px;
  }
}

// Tabs z-index
.pri-tabs {
  z-index: 2;
}

.pri-tab-items {
  z-index: 1;
}

.dollarSignBig {
  font-size: 36px;
}

.dollarSignSmall {
  font-size: 28px;
}

.dollarSignIconBig {
  font-size: 56px;
}

.dollarSignIconSmall {
  font-size: 36px;
}

.makeAPaymentFontBig {
  font-size: 24px;
  display: block;
  margin-top: -5px;
  padding-bottom: 20px;
}

.makeAPaymentFontSmall {
  font-size: 16px;
  display: block;
  margin-top: -2px;
  padding-bottom: 5px;
}

.updateMonthlyWDFontBig {
  font-size: 36px;
  display: block;
  margin-top: -5px;
  padding-bottom: 20px;
}

.updateMonthlyWDFontSmall {
  font-size: 18px;
  display: block;
  margin-top: -2px;
  padding-bottom: 5px;
}

.center-text-with-image {
  align-items: center;
  display: flex;
}

:deep(.v-slide-group__content .v-btn__content) {
  @media only screen and (max-width: 599px) {
    font-size: 12px !important;
  }
}

.single-policy {
  @media only screen and (min-width: 861px) {
    padding-top: 0.35rem;
  }
  @media only screen and (min-width: 320px) and (max-width: 860px) {
    padding-top: 0.75rem;
  }
}

.multi-policies {
  @media only screen and (min-width: 861px) {
    padding-top: 0.35rem;
  }
  @media only screen and (min-width: 320px) and (max-width: 860px) {
    padding-top: 0.75rem;
    margin-left: 0.15rem;
  }
}
</style>
